module.exports = __webpack_public_path__ + "static/media/dashboard.0f92b392.svg";